import { auditReports } from '@mi-front/api-clients';
import { Link } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { GipExportLauncher } from '../export-modal/GipExportLauncher';

interface ReExportSectionProps {
  reportId: string;
  reportType: string;
  exportOptions: auditReports.GipEvidenceExportOptionsDto;
  onExport: (config: auditReports.GipEvidenceExportOptionsDto) => Promise<void>;
}

/**
 * Re-export section component that provides an "Avanzado" link
 * to reveal a re-export button with pre-populated export options.
 */
export const ReExportSection = ({
  reportId,
  reportType,
  exportOptions,
  onExport,
}: ReExportSectionProps) => {
  const [showReExport, setShowReExport] = useState(false);

  return (
    <div className="mt-2">
      <Link
        component="button"
        variant="body2"
        onClick={() => setShowReExport(true)}
        sx={{ cursor: 'pointer' }}
      >
        <FormattedMessage id="audit.gipReport.export.advancedLink" defaultMessage="Avanzado" />{' '}
      </Link>
      {showReExport && (
        <div className="mt-2">
          <GipExportLauncher
            initialConfig={exportOptions}
            reportType={reportType}
            onExport={onExport}
            retry
          />
        </div>
      )}
    </div>
  );
};
